export default __webpack_public_path__ + "static/media/u14.f475ea89.png";